const NotFoundPage: React.FC = () => {
  return <div>Not Found</div>;
};

export default NotFoundPage;
